﻿class archdatadiff_tifsk extends Tango.Component {
	widgetDidMount() {
		const savebtn = document.getElementById("info_ti_replacearchcomm_savebtn");
		var _this = this;
		if (savebtn)
			savebtn.addEventListener("click", function () {
				document.querySelector("input[name='diffti']").value = encodeURIComponent(JSON.stringify(_this.state.diff));
			});
		document.querySelectorAll("a[data-openDialog]").forEach(function (a) {
			var arg = a.getAttribute('data-openDialog');
			a.addEventListener("click", function () {
				_this.openDialog(arg = '' ? null : arg);
			});
		});
		document.querySelectorAll("a[data-clear]").forEach(function (a) {
			var arg = a.getAttribute('data-clear');
			a.addEventListener("click", function () {
				_this.clear(arg = '' ? null : arg);
			});
		});
	}

	openDialog(field) {
		if (field == null && document.querySelectorAll("input.type-reason[data-drl='2']:checked").length == 0) {
			alert('Не выбраны получасовки для установки причины');
			return;
		}
		const sd = document.getElementById(this.props.selectDialogID);
		if (window.innerWidth > 800)
			sd.style.width = window.innerWidth - 500 + 'px';
		else
			sd.style.width = 500 + 'px';
		dialog.open(sd);

		this._pendingSelection = null;

		sd.querySelectorAll("tr[data-reasonid] a").forEach(function (a) {
			a.onclick = function () {
				const isCollapsed = this.firstChild.classList.contains('icon-collapsed');
				if (isCollapsed) {
					this.childNodes[0].classList.remove('icon-collapsed');
					this.childNodes[0].classList.add('icon-expanded');
					sd.querySelectorAll("tr[data-reasonid='" + this.parentElement.parentElement.getAttribute('data-reasonid') + "'][data-caseid]").forEach(function (el) {
						el.classList.remove('hide');
					});
				}
				else {
					this.childNodes[0].classList.add('icon-collapsed');
					this.childNodes[0].classList.remove('icon-expanded');
					sd.querySelectorAll("tr[data-reasonid='" + this.parentElement.parentElement.getAttribute('data-reasonid') + "'][data-caseid]").forEach(function (el) {
						el.classList.add('hide');
					});
				}
			}
		});
		var _this = this;
		sd.querySelectorAll(".reasonsselect-level2").forEach(function (tr) {
			tr.onclick = function () {
				sd.querySelectorAll("tr.reasonsselect-level2").forEach(function (row) {
					row.classList.remove("selected");
				});
				tr.classList.add("selected");

				var caseid = tr.getAttribute("data-caseid");
				var reasonid = tr.getAttribute("data-reasonid");
				var casename = tr.getAttribute("data-case");
				var reasonname = tr.getAttribute("data-reason");
				var caseNumber = tr.querySelector(".archdatareasoncaseicon").innerHTML;
				var reasonNumber = tr.querySelector(".archdatareasoncaseicon").getAttribute("data-reasonnumber");

				_this._pendingSelection = {
					archDataDiffReason_ID: reasonid,
					archDataDiffReasonNumber: reasonNumber,
					archDataDiffReasonCase_ID: caseid,
					archDataDiffReasonCaseNumber: caseNumber,
					casename: casename,
					reasonname: reasonname,
					field: field
				};
			};
		});

		sd.querySelectorAll(".archdatareasoncaseicon").forEach(function (div) {
			div.onclick = function (e) {
				e.stopPropagation();
				var td = div.parentElement;
				var tr = td.parentElement;
				tr.onclick();
			};
		});

		return false;
	}

	closeDialog() {
		this._pendingSelection = null;
		var sd = document.getElementById(this.props.selectDialogID);

		var rReason = sd.querySelector("select[name='reservereason']");
		var rMethod = sd.querySelector("select[name='reservemethod']");
		rReason.selectedIndex = -1;
		rMethod.selectedIndex = -1;

		sd.querySelectorAll("tr.reasonsselect-level2.selected").forEach(function (row) {
			row.classList.remove("selected");
		});

		dialog.close(sd);
	}

	clear(field) {

		if (field == null && document.querySelectorAll("input.type-reason[data-drl='2']:checked").length == 0) {
			alert('Не выбраны получасовки для снятия причины');
			return;
		}

		var names = [];
		if (field == null) {
			document.querySelectorAll("input.type-reason[data-drl='2']:checked").forEach(function (el) {
				var name = el.getAttribute("name");
				name = name.substring(0, name.length - 3);
				names.push(name);
			});
		}
		else {
			names.push(field);
		}
		var _this = this;
		names.forEach(function (name) {
			if (_this.state.diff[name]) {
				_this.state.diff[name].archDataDiffReasonCase_ID = 0;
				_this.state.diff[name].archDataDiffReason_ID = 0;
				_this.state.diff[name].reserveCalcReason_ID = 0;
				_this.state.diff[name].reserveCalcMethod_ID = 0;
			}

			var col_r = document.querySelector("div[data-id='" + name + "_r']");
			col_r.classList.add("hide");
			var col_rr = document.querySelector("div[data-id='" + name + "_rr']");
			col_rr.classList.add("hide");
			var col_rm = document.querySelector("div[data-id='" + name + "_rm']");
			col_rm.classList.add("hide");
			var col_c = document.querySelector("div[data-id='" + name + "']");
			col_c.classList.add("hide");

			var del = document.querySelector("a[data-clear='" + name + "']");
			del.classList.add("hide");
		});
	}

	applySelectReason() {
		if (!this._pendingSelection) {
			alert('Не выбран случай расхождения');
			return;
		}

		var selection = this._pendingSelection;
		var names = [];

		if (selection.field == null) {
			document.querySelectorAll(":not(.cantsetreason) input.type-reason[data-drl='2']:checked").forEach(function (el) {
				const tr = el.parentNode.parentNode;
				if (tr.classList.contains('cantsetreason'))
					return;
				var name = el.getAttribute("name");
				name = name.substring(0, name.length - 3);
				names.push(name);
			});
		}
		else {
			names.push(selection.field);
		}

		var sd = document.getElementById(this.props.selectDialogID);
		var rReason = sd.querySelector("select[name='reservereason']");
		var rMethod = sd.querySelector("select[name='reservemethod']");

		var rReasonid = rReason.value ?? "0";
		var rMethodid = rMethod.value ?? "0";
		var rReasontxt = rReason.options[rReason.selectedIndex]?.text ?? "";
		var rMethodtxt = rMethod.options[rMethod.selectedIndex]?.text ?? "";

		sd.querySelectorAll("tr.reasonsselect-level2.selected").forEach(function (row) {
			row.classList.remove("selected");
		});
		rReason.selectedIndex = -1;
		rMethod.selectedIndex = -1;

		var _this = this;
		names.forEach(function (name) {
			if (!_this.state.diff[name])
				_this.state.diff[name] = {};
			_this.state.diff[name].archDataDiffReason_ID = selection.archDataDiffReason_ID;
			_this.state.diff[name].archDataDiffReasonNumber = selection.archDataDiffReasonNumber;
			_this.state.diff[name].archDataDiffReasonCase_ID = selection.archDataDiffReasonCase_ID;
			_this.state.diff[name].archDataDiffReasonCaseNumber = selection.archDataDiffReasonCaseNumber;
			_this.state.diff[name].archDataDiffReasonCase_ID = selection.archDataDiffReasonCase_ID;
			_this.state.diff[name].reserveCalcReason_ID = rReasonid;
			_this.state.diff[name].reserveCalcMethod_ID = rMethodid;

			var col_r = document.querySelector("div[data-id='" + name + "_r']");
			col_r.innerHTML = selection.archDataDiffReasonNumber;
			col_r.classList.remove("hide");
			col_r.setAttribute("title", selection.reasonname);

			while (col_r.classList.length > 0) {
				col_r.classList.remove(col_r.classList.item(0));
			}
			col_r.classList.add("archdatareasoncol");
			col_r.classList.add("archdatareasoncol_" + selection.archDataDiffReasonNumber);

			var col_c = document.querySelector("div[data-id='" + name + "']");
			col_c.innerHTML = selection.archDataDiffReasonCaseNumber;
			col_c.classList.remove("hide");
			col_c.setAttribute("title", selection.casename);

			var col_rr = document.querySelector("div[data-id='" + name + "_rr']");
			col_rr.innerHTML = rReasontxt;
			col_rr.classList.remove("hide");
			var col_rm = document.querySelector("div[data-id='" + name + "_rm']");
			col_rm.innerHTML = rMethodtxt;
			col_rm.classList.remove("hide");

			var del = document.querySelector("a[data-clear='" + name + "']");
			del.classList.remove("hide");
		});

		this._pendingSelection = null;
		dialog.close(sd);
	}
};

Tango.registerComponent(archdatadiff_tifsk, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils,
	moment: moment,
	btnSwitchCtor: id => sp.components.btnswitch(id, sp)
}));